import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { DialogProvider } from './contexts/DialogContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Routes from './Routes';
import FloatingContactButtons from './components/FloatingContactButtons';
import CartSidebar from './components/ui/CartSidebar';

// Composant qui utilise les fournisseurs de contexte
const AppContent = () => {
  return (
    <>
      <Routes />
      <FloatingContactButtons />
      <CartSidebar />
    </>
  );
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <CartProvider>
            <DialogProvider>
              <AppContent />
            </DialogProvider>
          </CartProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;